<template>
    <div class="header-wrapper">
        <div class="header">
            <router-link to="/" class="logo">
                <!-- <img src="../../assets/images/jd_course_logo.png"> -->
                {{ app }}
            </router-link>
            <el-menu :default-active="activeIndex" class="nav" mode="horizontal" @select="selectRouter" v-if="!islogin">
                <el-menu-item index="qualityStudentCourse" v-if="role!=3">
<!--                    <router-link class="nav-item" :to="{name: 'qualityCourse'}">课程</router-link>-->
                    <router-link class="nav-item" :to="class_status==1?'/qualityCourse/courseindex':'/qualityCourse/defaultPage'">课程</router-link>
                </el-menu-item>
                <el-menu-item index="qualityCourse" v-if="role===3">
                    <router-link class="nav-item" to="/qualityCourse/teacher/index">课程</router-link>
                </el-menu-item>
                <el-menu-item index="classRecord" v-if="role === 3">
                    <router-link class="nav-item" to="/qualityCourse/classRecord">上课记录</router-link>
                </el-menu-item>
                <el-menu-item index="qualityEducational"  v-if="role === 3">
                    <router-link class="nav-item" to="/qualityCourse/educational">教务管理</router-link>
                </el-menu-item>
                <!--<el-menu-item index="training">-->
					<!--<a :href="softUrl" target="_blank" class="nav-item">实训系统</a>-->
                <!--</el-menu-item>-->
                <el-menu-item index="myClass" v-if="role === 4">
                    <router-link class="nav-item" to="/myclass/detail">我的班级</router-link>
                </el-menu-item>
				<el-menu-item index="myClass"  v-if="role === 3">
				    <router-link class="nav-item" to="/myClass">我的班级</router-link>
				</el-menu-item>
                <el-menu-item index="qualityCoursePublicClass">
                    <router-link class="nav-item" to="/qualityCourse/PublicClass">公开课</router-link>
                </el-menu-item>
                <el-menu-item index="qualityCourseProjectClassify">
                    <router-link class="nav-item" to="/qualityCourse/projectclassify">项目库</router-link>
                </el-menu-item>

                <!--<el-menu-item index="qualityCourseNewsCenter" v-if="role === 3">-->
                    <!--<router-link class="nav-item" to="/qualityCourse/newsCenter">新闻中心</router-link>-->
                <!--</el-menu-item>-->
                <!--<el-menu-item index="qualityCourseAnalysisManagementCenter" v-if="role===3">
                    <router-link class="nav-item" to="/qualityCourse/analysisManagementCenter">学习分析管理</router-link>
                </el-menu-item>-->
                 <!--<el-menu-item index="qualityCourseLearningCenter" v-if="role===3">
                    <router-link class="nav-item" to="/qualityCourse/learningCenter">学习中心</router-link>
                </el-menu-item>-->
                <el-menu-item index="qualityCourseHeroesLeaderboard">
                    <router-link class="nav-item" to="/qualityCourse/heroesLeaderboard">英雄榜</router-link>
                </el-menu-item>
                <el-menu-item index="dataEvaluationIndex" v-if="role === 3">
                    <router-link class="nav-item" to="/qualityCourse/teacher/dataEvaluationIndex">综合数据评价</router-link>
                </el-menu-item>
                <el-menu-item index="studentDataEvaluationIndex" v-else>
                    <router-link class="nav-item" to="/qualityCourse/student/dataEvaluationIndex">综合数据评价</router-link>
                </el-menu-item>
                <!--  -->
                <el-menu-item index="teachIndex" v-if="role === 3">
                    <router-link class="nav-item" to="/teach/index">题库</router-link>
                </el-menu-item>
                <el-menu-item index="qualityCourseApplicationCenter">
                    <router-link class="nav-item" to="/qualityCourse/applicationCenter">应用中心</router-link>
                </el-menu-item>
            </el-menu>
            <div class="user" v-if="!islogin">
                <div class="m-userinfo">
                    <router-link :to="{path: '/teacher'}" v-if="!isLogin" >教师登录</router-link>
                </div>
                <div class="user-info">
                    <div class="user-avatar">
                        <img :src="userIcon ? userIcon : require('../../assets/images/user_img.png')" alt="" />
                    </div>
                    <el-dropdown class="header-el-dropdown" v-if="isLogin" @command="logout">
                    <span class="user-text">
                            <span class="user-name text-overflow">{{username}}</span>
                            <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-user"  command="2">个人中心</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-circle-plus-outline"  v-if="role === 4"  command="3">加入班级</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-switch-button" command="1">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <el-dialog
        title="加入班级" :close-on-click-modal="false"
        :visible.sync="dialogClassVisible"
        width="700px" :modal="false"
        :before-close="handleClassClose">
        <div class="class_box">
            <div class="image_box">
                <img v-if="userIcon" :src="userIcon" alt="">
                <img v-else src="../../assets/images/user_img.png" alt="">
            </div>
            <p style="margin: 30px 0;" v-if="class_status==1">您已经加入班级</p>
            <p style="margin: 30px 0;" v-if="class_status==0">请输入您要加入的班级邀请码</p>
            <el-input  v-if="class_status==0" style="width: 220px;" v-model="addCode" placeholder="请输入班级邀请码"></el-input>
        </div>
        <span   v-if="class_status==0" slot="footer" class="dialog-footer" style="display: flex;justify-content: center;">
            <el-button @click="handleClassClose" size="medium">取 消</el-button>
            <el-button type="primary" size="medium" @click="confirmFn">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import config  from '@/config/config';
    export default {
        name: "HeaderModule",
        data() {
            return {
                activeIndex: '',
                isLogin: false,
				role: '',
                username: '',
                userIcon: '',
                softUrl: localStorage.getItem('softUrl') ? localStorage.getItem('softUrl') : 'http://shixun.jdekt.com/',
                dialogClassVisible:false,
                addCode:"",
                icon:localStorage.getItem('sIcon'),
                class_status:0
            }
        },
        props: ['islogin'],
        computed: {
            app: () => config.appName
        },
        created() {
            console.log("this.$route.name",this.$route.path);
            
            if (this.$route.name.indexOf('teacherCourseIndex') !== -1 || this.$route.path === "/teach/mark") {
                this.activeIndex = 'qualityCourse';
            } else if (this.$route.name.indexOf('studentCourseIndex') !== -1) {
                this.activeIndex = 'qualityStudentCourse';
            } else if (this.$route.name.indexOf("teachIndex") !== -1) {
                this.activeIndex = "teachIndex";
            } else if(this.$route.name.indexOf('qualityDefaultPage')!==-1){
                    this.activeIndex = 'qualityStudentCourse';
                } else if (this.$route.path === "teacherClass/allApprovedDetail") {
                    this.activeIndex = "myClass"
                }
            else {
                this.activeIndex = this.$route.name;
            }

            if (localStorage.getItem('sUsername')) {
                this.isLogin = true;
            } else {
                this.isLogin = false;
            }
            this.class_status=localStorage.getItem("class_status")
			this.watchRole();
        },
        mounted() {
            this.username = localStorage.getItem('sUsername');
            // if (!this.username) {
            //     this.$router.push('/');
            // }

            let userIcon = localStorage.getItem('sIcon');
            if (userIcon !== 'null') {
                this.userIcon = userIcon;
            }
        },
        watch: {
            '$route'(to, from) {
                console.log("to.name",to.name);
                console.log("regrex", to.fullPath.indexOf("/teach"))
                // 课程目录下
                let qualityCourseArr = [
                    "teacherCourseIndex",
                    "teachingActivitiesOperate",
                    "qualityCourse",
                    "literacyEvaluationView",
                    "teachingActivityDetial",
                    "weightSetting",
                    "teachMark",
                    "ScoreBreakdown",
                    "studentLeaderBoardDetialAttidute",
                    "studentLeaderBoardDetialSkill",
                    "studentLeaderBoardDetialAttiduteKnowledge",
                    "studentLeaderBoardDetialLiteracy"
                ];
                // 学生端 课程目录
                let studentQualityCourseArr = [
                    "studentCourseIndex",
                    "studentReferenceMaterial",
                    "studentLiteracy",
                    "ActivitiesOperate",
                    "ActivityDetial",
                    "studentLeaderboard",
                    "qualityDefaultPage",
                    "studentScoreBreakdown",
                ];
                let evaluationRouteArr = [
                    "dataEvaluationIndex",
                    "dataEvaluation",
                    "dataLiteracy",
                    "dataLiteracyDetail",
                    "dataTraining",
                    "dataAttitude",
                    "dataAttitudeDetail",
                    "dataknowledge",
                    "dataExamResult", 
                ];

                let studentEvaluationRouteArr = [
                    "studentDataEvaluationIndex",
                    "studentDataEvaluation",
                    "studentDataLiteracy",
                    "studentDataTraining",
                    "studentDataAttitude",
                    "studentDataExam",
                    "studentDataKnowledge",
                    
                ];

                if (qualityCourseArr.includes(to.name) ) {
                    this.activeIndex = 'qualityCourse';
                } else if (studentQualityCourseArr.includes(to.name)) {
                    this.activeIndex = 'qualityStudentCourse';
                } else if (evaluationRouteArr.includes(to.name)) {
                    this.activeIndex = "dataEvaluationIndex";
                } else if (studentEvaluationRouteArr.includes(to.name)) {
                    this.activeIndex = "studentDataEvaluationIndex";
                } else if (to.name.indexOf('qualityCreateClass') !== -1){
                    this.activeIndex='qualityEducational'
                } else if (to.name.indexOf("teachIndex") !== -1) {
                    this.activeIndex = "teachIndex"
                }else if(to.name.indexOf('qualityCourseProjectscoreBreakdown')!==-1){
                    this.activeIndex='qualityCourseProjectClassify'
                }else if(to.name.indexOf('teacherClassScoreBreakdown')!==-1){
                    this.activeIndex='myClass'
                }  else {
                    this.activeIndex = to.name;
                }

                if (localStorage.getItem('sUsername')) {
                    this.isLogin = true;
                } else {
                    this.isLogin = false;
                }
                console.log("  this.activeIndex",  this.activeIndex);
                
				// 监听角色
				this.watchRole();
            }
        },
        methods: {
			watchRole() {
				this.role = parseInt(localStorage.getItem('role'));
			},
            reload() {
                setTimeout(() => window.location.reload(), 1000)
            },
            logout(command) {
                if(command==1){
                        this.$shttp.axiosGet(this.$api.logout, (res) => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                duration: 1000,
                                message: res.msg,
                                onClose: ()=> {
                                    localStorage.clear()
                                    this.$store.commit("CLEAR_COURSE_RESOURCE")
                                    if (this.$route.path === '/'){
                                        window.location.reload();
                                    } else {
                                        this.$router.push('/');
                                        // this.reload();
                                    }
                                }
                            })
                        } else {
                            this.$message({
                                type: 'warning',
                                duration: 1000,
                                message: res.msg,
                                onClose: ()=> {
                                    localStorage.clear()
                                    this.$store.commit("CLEAR_COURSE_RESOURCE")
                                    if (this.$route.path === '/'){
                                        window.location.reload();
                                    } else {
                                        this.$router.push('/');
                                        // this.reload();
                                    }
                                }
                            })
                        }
                        
                    })
                }else if(command==2){
                    console.log("前往个人中心");
                    this.$router.push("/qualityCourse/IndividualCenter")

                }else{
                    // 加入班级出现弹框
                    this.class_status=localStorage.getItem("class_status")
                    let userIcon = localStorage.getItem('sIcon');
                    if (userIcon !== 'null') {
                            this.userIcon = userIcon;
                        }
                    

                    this.dialogClassVisible=true
                }
            },
            selectRouter(key, keyPath) {
                switch (key) {
                    case 'qualityCourse':
                        this.activeIndex = key;
                        break;
                    case 'qualityStudentCourse':
                        this.activeIndex = key;
                        break;
                    case 'qualityCoursePublicClass':
                        this.activeIndex = key;
                        break;
                    case 'qualityCourseProjectClassify':
                        this.activeIndex=key;
                        break;
                    case 'qualityCourseLearningCenter':
                        this.activeIndex=key;
                        break;
                    case 'qualityCourseAnalysisManagementCenter':
                        this.activeIndex=key;
                        break;
                    case 'qualityCourseHeroesLeaderboard':
                        this.activeIndex=key;
                        break;

                    case 'qualityCourseApplicationCenter':
                        this.activeIndex=key;
                        break;
                    case 'qualityEducational':
                        this.activeIndex = key;
                        break;
                    case 'classRecord':
                        this.activeIndex = key;
                        break;
                    case 'myClass':
                        this.activeIndex = key;
                        break;
                    case "dataEvaluationIndex":
                        this.activeIndex = key;
                        break;
                    case "studentDataEvaluationIndex":
                        this.activeIndex = key;
                        break;
                    case "teachIndex":
                        this.activeIndex = key;
                        break;
                    default:
                        this.activeIndex = null;
                        let elements = document.getElementsByClassName('el-menu-item');
                        for (let i=0; i<elements.length; i++) {
                            elements[i].className = 'el-menu-item';
                        }
                        break;
                }
            },
            handleClassClose(){
                this.dialogClassVisible=false
            },
            confirmFn(){
                if (!this.addCode) {
                    this.$message.warning("邀请码不能为空");
                    return;
                }
                this.$http.axiosPost(
                    this.$api.jdJoinClass,
                    { invitation_code: this.addCode },
                    (res) => {
                    if (res.code === 200) {
                        this.$message.success("加入成功");
                        localStorage.setItem("class_status",1)
                        this.class_status=1
                        this.$router.push('/qualityCourse/courseindex');
                    } else {
                        this.$message({
                        type: "error",
                        message: res.msg,
                        });
                    }
                    },
                    (err) => {
                    console.log(err);
                    this.$message({
                        type: "error",
                        message: "邀请码不正确",
                    });
                    }
                );
                this.dialogClassVisible = false;
              
            }
        }
    }
</script>

<style scoped lang="scss">
    .header-wrapper {
        width: 100%;
        background: #fff;
        border-bottom: 1px solid #dcdfe6;
        .header {
            position: relative;
            width: 1200px;
            height: 60px;
            line-height: 60px;
            margin: 0 auto;
            display: flex;
            .nav {
                flex: 1;
                width: 1%;
                border-bottom: none;
                .el-menu-item {
                    padding: 0;
                    .nav-item {
                        display: block;
                        padding: 0 20px;
                    }
                }
            }
            .logo {
                /*width: 200px;*/
                font-size: 18px;
                font-weight: 600;
                margin-right: 20px;
                overflow: hidden;
            }
            .user {
                text-align: right;
                margin-left: 20px;
                span {
                    font-size: 16px;
                    margin-right: 20px;
                }
            }
        }
    }
    .quality-course-container {
        .header-wrapper {
            display: block;
            z-index: 1001;
            height: 70px;
            width: 100%;
            box-shadow: 0 0 5px rgba(0,0,0,0.1), 0 0 5px rgba(0,0,0,0.1);
            background: #fff;
            /*min-width: 1000px;*/
            border-bottom: none;
            .header {
                width: 100%;
                padding: 0 150px;
                box-sizing: border-box;
                .logo {
                    width: 200px;
                    height: 70px;
                    cursor: pointer;
                    margin: 0;
                    /*height: 100%;*/
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin-right: 8px;
                    img {
                        /*width: 130px;
                        max-width: 100%;*/
                        /*height: auto;*/
                        /*width: 100%;*/
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
                .user {
                    display: flex;
                    .m-userinfo {
                        a {
                            display: block;
                            font-size: 16px;
                            color: #666;
                        }
                    }
                }
                .user .header-el-dropdown{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    padding: 10px 0;
                    .user-text {
                        line-height: 40px;
                        margin-left: 10px;
                    }
                    img {
                        display: block;
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                    }
                }
            }
        }
        .el-dropdown-menu {
            ::v-deep li {
                padding: 0 25px 0 10px;
                height: 27px;
                line-height: 27px;
                font-size: 14px;
                color: #666;
                &:hover {
                    color: #4A90E2;
                    background-color: transparent;
                }
                i {
                    font-size: 16px;
                    color: #666;
                }
            }
        }
    }
    .user-info {
        display: flex;
        align-items: center;
        height: 70px;
        .user-avatar {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #ddd;
            img {
                max-width: 100%;
                max-height: 100%;
            }
        }
        .el-dropdown {
            .user-text {
                display: flex;
                align-items: center;
                &:hover {
                    color: #409EFF;
                }
                .user-name {
                    max-width: 80px;
                    display: block;
                    cursor: pointer;
                    &:focus {
                        outline: none;
                    }
                }
            }
            padding-left: 20px;
        }
    }
    .class_box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .image_box{
            width: 46px;
            height: 46px;
            border-radius: 4px;
            img{
                border-radius: 4px;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

        }
    }
    @media (min-width: 576px) {
        .quality-course-container .container {
            max-width: 540px;
        }
    }
    @media (min-width: 768px) {
        .quality-course-container .container {
            max-width: 720px;
        }
    }
    @media (min-width: 992px) {
        .quality-course-container .container {
            max-width: 960px;
        }
    }
    @media (min-width: 1200px) {
        .quality-course-container .container {
            max-width: 1192px;
        }
    }
</style>
